const LOC = { type: "loc" };

const PAGE_OPTIONS = [
  { value: "home", label: "Anasayfa" },
  { value: "products", label: "Ürünler" },
  { value: "services", label: "Hizmetler" },
  { value: "portfolio", label: "Portföy" },
  { value: "about", label: "Hakkımızda" },
  { value: "contact", label: "İletişim" },
];

const ANCHOR_OPTIONS = [
  { value: "bottom", label: "Sayfa sonu (footer üstü)" },
  { value: "afterStudio", label: "Anasayfa: stüdyo bölümünün altı" },
  { value: "afterWork", label: "Anasayfa: seçilmiş işler altı" },
  { value: "afterProcess", label: "Hizmetler: [ HOW THE PROCESS WORKS ] altı" },
  { value: "afterTeam", label: "Hakkımızda: ekip bölümünün altı" },
  { value: "top", label: "Sayfa başı (başlığın altı)" },
];

export const SECTIONS = {
  menu: {
    key: "menu",
    label: "[ MENÜ ]",
    title: "Menü yönetimi",
    fields: [
      { name: "ctaLabel", label: "SAĞ ÜST BUTON YAZISI", ...LOC },
      {
        name: "items",
        label: "ÜST MENÜ BAŞLIKLARI",
        type: "list",
        itemLabel: "path",
        newItem: { label: { en: "", fi: "", tr: "", es: "" }, path: "/", visible: true, auto: "", children: [] },
        fields: [
          { name: "label", label: "MENÜ BAŞLIĞI", ...LOC },
          { name: "path", label: "BAĞLANTI (örn. /products)", type: "text" },
          {
            name: "auto",
            label: "OTOMATİK ALT MENÜ",
            type: "select",
            options: [
              { value: "", label: "Kapalı" },
              { value: "collections", label: "Ana kategorileri otomatik listele" },
            ],
            hint: "Açık olduğunda panelden eklenen her ana kategori bu menünün altında otomatik görünür.",
          },
          { name: "visible", label: "MENÜDE", type: "bool" },
          {
            name: "children",
            label: "ELLE EKLENEN ALT MENÜLER",
            type: "list",
            itemLabel: "path",
            newItem: { label: { en: "", fi: "", tr: "", es: "" }, path: "/", visible: true },
            fields: [
              { name: "label", label: "ALT MENÜ BAŞLIĞI", ...LOC },
              { name: "path", label: "BAĞLANTI", type: "text" },
              { name: "visible", label: "MENÜDE", type: "bool" },
            ],
          },
        ],
      },
    ],
  },
  sayfalar: {
    key: "pages",
    label: "[ SAYFA METİNLERİ ]",
    title: "Tüm sayfa metinleri",
    fields: [
      { name: "productsIndex", label: "ÜRÜNLER · ÜST ETİKET", ...LOC },
      { name: "productsTitle", label: "ÜRÜNLER · BAŞLIK", ...LOC },
      { name: "productsLead", label: "ÜRÜNLER · GİRİŞ METNİ", ...LOC, multiline: true },
      { name: "productsCollectionsLabel", label: "ÜRÜNLER · KOLEKSİYON ETİKETİ", ...LOC },
      { name: "productsLinesLabel", label: "ÜRÜNLER · SERİ ETİKETİ", ...LOC },

      { name: "servicesIndex", label: "HİZMETLER · ÜST ETİKET", ...LOC },
      { name: "servicesTitle", label: "HİZMETLER · BAŞLIK", ...LOC },
      { name: "servicesLead", label: "HİZMETLER · GİRİŞ METNİ", ...LOC, multiline: true },
      { name: "servicesProcessLabel", label: "HİZMETLER · SÜREÇ ETİKETİ", ...LOC },
      { name: "servicesProcessTitle", label: "HİZMETLER · SÜREÇ BAŞLIĞI", ...LOC },
      { name: "servicesProductionLabel", label: "HİZMETLER · ÜRETİM ETİKETİ", ...LOC },
      { name: "servicesProductionTitle", label: "HİZMETLER · ÜRETİM BAŞLIĞI", ...LOC },
      { name: "servicesProductionText", label: "HİZMETLER · ÜRETİM METNİ", ...LOC, multiline: true },
      { name: "servicesProductionCta", label: "HİZMETLER · ÜRETİM BUTONU", ...LOC },
      { name: "servicesProductionImage", label: "HİZMETLER · ÜRETİM GÖRSELİ", type: "image" },

      { name: "portfolioIndex", label: "PORTFÖY · ÜST ETİKET", ...LOC },
      { name: "portfolioTitle", label: "PORTFÖY · BAŞLIK", ...LOC },
      { name: "portfolioLead", label: "PORTFÖY · GİRİŞ METNİ", ...LOC, multiline: true },

      { name: "aboutIndex", label: "HAKKIMIZDA · ÜST ETİKET", ...LOC },
      { name: "aboutTitle", label: "HAKKIMIZDA · BAŞLIK", ...LOC },
      { name: "aboutPartnersLabel", label: "HAKKIMIZDA · EKİP ETİKETİ", ...LOC },
      { name: "aboutHowLabel", label: "HAKKIMIZDA · NASIL ÇALIŞIYORUZ ETİKETİ", ...LOC },
      { name: "aboutHowCta", label: "HAKKIMIZDA · BUTON YAZISI", ...LOC },

      { name: "contactIndex", label: "İLETİŞİM · ÜST ETİKET", ...LOC },
      { name: "contactTitle", label: "İLETİŞİM · BAŞLIK", ...LOC },
      { name: "contactLead", label: "İLETİŞİM · GİRİŞ METNİ", ...LOC, multiline: true },
      { name: "contactFormLabel", label: "İLETİŞİM · FORM ETİKETİ", ...LOC },
      { name: "contactHoursLabel", label: "İLETİŞİM · ÇALIŞMA SAATİ ETİKETİ", ...LOC },
      { name: "contactLocationsLabel", label: "İLETİŞİM · KONUM ETİKETİ", ...LOC },
      { name: "contactMapTitle", label: "İLETİŞİM · HARİTA BAŞLIĞI", ...LOC },
      { name: "contactMapNote", label: "İLETİŞİM · HARİTA NOTU", ...LOC, multiline: true },
    ],
  },
  "anasayfa-slayder": {
    key: "hero",
    label: "[ ANASAYFA SLAYDER ]",
    title: "Anasayfa slayder",
    fields: [
      { name: "autoplay", label: "OTOMATİK GEÇİŞ SÜRESİ (saniye)", type: "text" },
      {
        name: "items",
        label: "SLAYTLAR",
        type: "list",
        itemLabel: "title",
        newItem: {
          id: "",
          no: "",
          title: "",
          image: "",
          kicker: { en: "", fi: "", tr: "", es: "" },
          text: { en: "", fi: "", tr: "", es: "" },
          link: "/products",
          visible: true,
        },
        fields: [
          { name: "no", label: "NO", type: "text" },
          { name: "title", label: "SLAYT BAŞLIĞI", type: "text" },
          { name: "image", label: "SLAYT GÖRSELİ", type: "image" },
          { name: "kicker", label: "ÜST ETİKET", ...LOC },
          { name: "text", label: "METİN", ...LOC, multiline: true },
          { name: "id", label: "KOLEKSİYON ANAHTARI (teknik veriler için)", type: "text" },
          {
            name: "link",
            label: "BAĞLANTI (ürün / koleksiyon sayfası)",
            type: "text",
            hint: "Örn. /products/kaari veya /portfolio",
          },
          { name: "visible", label: "SİTEDE GÖSTER", type: "bool" },
        ],
      },
    ],
  },
  footer: {
    key: "footer",
    label: "[ ALT BÖLÜM ]",
    title: "Footer içeriği",
    fields: [
      { name: "label", label: "ÜST ETİKET", ...LOC },
      { name: "title", label: "BAŞLIK", ...LOC, multiline: true },
      { name: "ctaLabel", label: "BUTON YAZISI", ...LOC },
      { name: "navLabel", label: "MENÜ SÜTUNU ETİKETİ", ...LOC },
      { name: "rights", label: "TELİF METNİ", ...LOC },
      { name: "note", label: "SAĞ ALT NOT (boşsa felsefe metni)", ...LOC, multiline: true },
    ],
  },
  anasayfa: {
    key: "home",
    label: "[ ANASAYFA ]",
    title: "Anasayfa içeriği",
    fields: [
      { name: "studioLabel", label: "01 · STÜDYO BÖLÜM ETİKETİ", ...LOC },
      { name: "studioLead", label: "01 · STÜDYO GİRİŞ METNİ", ...LOC, multiline: true },
      { name: "showStudio", label: "01 · STÜDYO BÖLÜMÜ", type: "bool" },

      { name: "productsLabel", label: "02 · ÜRÜN HATLARI ETİKETİ", ...LOC },
      { name: "productsTitle", label: "02 · ÜRÜN HATLARI BAŞLIĞI", ...LOC },
      { name: "productsCta", label: "02 · ÜRÜN HATLARI BAĞLANTI YAZISI", ...LOC },
      {
        name: "productLines",
        label: "02 · ÜRÜN HATLARI",
        type: "list",
        itemLabel: "name",
        newItem: {
          id: "",
          tag: "",
          name: "",
          family: { en: "", fi: "", tr: "", es: "" },
          text: { en: "", fi: "", tr: "", es: "" },
          image: "",
          specs: [],
          to: "/products",
        },
        fields: [
          { name: "tag", label: "NO", type: "text" },
          { name: "name", label: "ÜRÜN HATTI ADI", type: "text" },
          { name: "family", label: "ÜST ETİKET", ...LOC },
          { name: "text", label: "AÇIKLAMA", ...LOC, multiline: true },
          { name: "image", label: "GÖRSEL", type: "image" },
          { name: "specs", label: "ETİKETLER (her satır bir etiket)", type: "strLines" },
          { name: "to", label: "BAĞLANTI", type: "text" },
        ],
      },
      { name: "showProductLines", label: "02 · ÜRÜN HATLARI BÖLÜMÜ", type: "bool" },

      { name: "ctaLabel", label: "03 · CTA ÜST ETİKETİ", ...LOC },
      { name: "ctaTitle", label: "03 · CTA BAŞLIĞI", ...LOC },
      { name: "ctaText", label: "03 · CTA METNİ", ...LOC, multiline: true },
      { name: "ctaButton", label: "03 · CTA BUTON YAZISI", ...LOC },
      { name: "ctaImage", label: "03 · CTA ARKA PLAN GÖRSELİ", type: "image" },
      { name: "showCta", label: "03 · CTA BÖLÜMÜ", type: "bool" },

      { name: "capabilitiesLabel", label: "04 · YETKİNLİKLER ETİKETİ", ...LOC },
      { name: "showCapabilities", label: "04 · YETKİNLİKLER BÖLÜMÜ", type: "bool" },

      { name: "philosophyLabel", label: "05 · FELSEFE ETİKETİ", ...LOC },
      { name: "quote", label: "05 · ALINTI", ...LOC, multiline: true },
      { name: "quoteAuthor", label: "05 · ALINTI SAHİBİ", type: "text" },
      { name: "showPhilosophy", label: "05 · FELSEFE BÖLÜMÜ", type: "bool" },

      { name: "workLabel", label: "06 · SEÇİLMİŞ İŞLER ETİKETİ", ...LOC },
      { name: "workTitle", label: "06 · SEÇİLMİŞ İŞLER BAŞLIĞI", ...LOC },
      { name: "workCta", label: "06 · SEÇİLMİŞ İŞLER BAĞLANTI YAZISI", ...LOC },
      { name: "showWork", label: "06 · SEÇİLMİŞ İŞLER BÖLÜMÜ", type: "bool" },

      {
        name: "slides",
        label: "HERO SLIDER",
        type: "list",
        itemLabel: "title",
        newItem: { id: "", no: "", title: "", image: "", kicker: { en: "", fi: "" }, text: { en: "", fi: "" } },
        fields: [
          { name: "no", label: "NO", type: "text" },
          { name: "title", label: "BAŞLIK", type: "text" },
          { name: "id", label: "KOLEKSİYON ANAHTARI", type: "text" },
          { name: "image", label: "SLIDE GÖRSELİ", type: "image" },
          { name: "kicker", label: "ÜST ETİKET", ...LOC },
          { name: "text", label: "METİN", ...LOC, multiline: true },
        ],
      },
    ],
  },
  hizmetler: {
    key: "services",
    label: "[ HİZMETLER ]",
    title: "Hizmetler",
    fields: [
      {
        name: "items",
        label: "HİZMET LİSTESİ",
        type: "list",
        itemLabel: "title",
        newItem: { no: "", title: { en: "", fi: "" }, text: { en: "", fi: "" }, points: { en: [], fi: [] } },
        fields: [
          { name: "no", label: "NO", type: "text" },
          { name: "title", label: "BAŞLIK", ...LOC },
          { name: "text", label: "AÇIKLAMA", ...LOC, multiline: true },
          { name: "points", label: "MADDELER (her satır bir madde)", type: "locStrings" },
        ],
      },
    ],
  },
  hakkimizda: {
    key: "about",
    label: "[ HAKKIMIZDA ]",
    title: "Hakkımızda",
    fields: [
      { name: "philosophy", label: "FELSEFE CÜMLESİ", ...LOC, multiline: true },
      { name: "studioImage", label: "STÜDYO GÖRSELİ", type: "image" },
      { name: "paragraphs", label: "METİN PARAGRAFLARI", type: "locArray", multiline: true },
      {
        name: "stats",
        label: "SAYAÇLAR",
        type: "list",
        itemLabel: "value",
        newItem: { value: "", label: { en: "", fi: "" } },
        fields: [
          { name: "value", label: "DEĞER", type: "text" },
          { name: "label", label: "ETİKET", ...LOC },
        ],
      },
      {
        name: "process",
        label: "ÇALIŞMA SÜRECİ",
        type: "list",
        itemLabel: "title",
        newItem: { no: "", title: { en: "", fi: "" }, text: { en: "", fi: "" } },
        fields: [
          { name: "no", label: "NO", type: "text" },
          { name: "title", label: "ADIM BAŞLIĞI", ...LOC },
          { name: "text", label: "AÇIKLAMA", ...LOC, multiline: true },
        ],
      },
    ],
  },
  ekip: {
    key: "team",
    label: "[ EKİP ]",
    title: "Ekip",
    fields: [
      {
        name: "items",
        label: "EKİP LİSTESİ",
        type: "list",
        itemLabel: "name",
        newItem: {
          name: "",
          image: "",
          role: { en: "", fi: "" },
          bio: { en: "", fi: "" },
          linkedin: "",
          linkedinEnabled: false,
          instagram: "",
          instagramEnabled: false,
          email: "",
          emailEnabled: false,
          visible: true,
        },
        fields: [
          { name: "name", label: "AD SOYAD", type: "text" },
          { name: "image", label: "PROFİL FOTOĞRAFI", type: "image" },
          { name: "role", label: "ÜNVAN", type: "loc" },
          { name: "bio", label: "BİYOGRAFİ", type: "loc", multiline: true },
          { name: "linkedin", label: "LINKEDIN BAĞLANTISI", type: "text" },
          { name: "linkedinEnabled", label: "LINKEDIN İKONU", type: "bool" },
          { name: "instagram", label: "INSTAGRAM BAĞLANTISI", type: "text" },
          { name: "instagramEnabled", label: "INSTAGRAM İKONU", type: "bool" },
          { name: "email", label: "E-POSTA ADRESİ", type: "text" },
          { name: "emailEnabled", label: "E-POSTA İKONU", type: "bool" },
          { name: "visible", label: "ÜYE SİTEDE", type: "bool" },
        ],
      },
    ],
  },
  referanslar: {
    key: "clients",
    label: "[ REFERANSLAR ]",
    title: "Referanslar & logo slider",
    fields: [
      {
        name: "items",
        label: "MARKALAR",
        type: "list",
        itemLabel: "name",
        newItem: { name: "", logo: "" },
        fields: [
          { name: "name", label: "MARKA ADI", type: "text" },
          { name: "logo", label: "LOGO (boş bırakılırsa yazı olarak gösterilir)", type: "image" },
        ],
      },
      { name: "sliderTitle", label: "SLIDER ÜST ETİKETİ (boşsa varsayılan metin)", ...LOC },
      { name: "sliderSpeed", label: "KAYMA HIZI (px/sn, önerilen 20-60)", type: "text" },
      {
        name: "placements",
        label: "LOGO SLIDER NEREDE GÖRÜNSÜN",
        type: "list",
        itemLabel: "page",
        newItem: { page: "home", anchor: "bottom", visible: true },
        fields: [
          { name: "page", label: "SAYFA", type: "select", options: PAGE_OPTIONS },
          { name: "anchor", label: "BÖLÜM / KONUM", type: "select", options: ANCHOR_OPTIONS },
          { name: "visible", label: "AKTİF", type: "bool" },
        ],
      },
    ],
  },
  iletisim: {
    key: "contact",
    label: "[ İLETİŞİM ]",
    title: "İletişim bilgileri",
    fields: [
      { name: "hours", label: "ÇALIŞMA SAATLERİ", ...LOC },
      {
        name: "offices",
        label: "OFİSLER",
        type: "list",
        itemLabel: "name",
        newItem: {
          country: "",
          name: "",
          address: [],
          phones: [],
          phoneNote: "",
          email: "",
          website: "",
          websiteLabel: "",
        },
        fields: [
          { name: "country", label: "ÜLKE", type: "text" },
          { name: "name", label: "OFİS ADI", type: "text" },
          { name: "city", label: "SİTEDE GÖRÜNEN ŞEHİR ETİKETİ", type: "loc" },
          { name: "address", label: "SİTEDE GÖRÜNEN ADRES (her satır ayrı)", type: "strLines" },
          { name: "mapAddress", label: "HARİTA / YOL TARİFİ İÇİN GERÇEK ADRES", type: "text" },
          { name: "lat", label: "HARİTA ENLEMİ (lat)", type: "text" },
          { name: "lng", label: "HARİTA BOYLAMI (lng)", type: "text" },
          { name: "mapNote", label: "HARİTA KARTI NOTU", type: "loc" },
          { name: "phones", label: "TELEFONLAR (her satır ayrı)", type: "strLines" },
          { name: "phoneNote", label: "TELEFON NOTU", type: "text" },
          { name: "email", label: "E-POSTA", type: "text" },
          { name: "website", label: "WEB SİTESİ (https://...)", type: "text" },
          { name: "websiteLabel", label: "WEB SİTESİ ETİKETİ", type: "text" },
        ],
      },
    ],
  },
};

